export default __webpack_public_path__ + "static/media/avatars(1).e3d44264.png";